module.exports = __webpack_public_path__ + "img/dataRecover.861411a4.png";